import { Money } from '@rabbit/data/types';
import { FBF_CloudCallable } from '@rabbit/firebase/adapter';

// TODO : As per the requirement, update the form schema to pass data for Updating the holding and holding proxy
export interface UpdateHoldingProxyRequest {
  holdingLink: string;
  formData: {
    purchase_price?: Money;
    additionalData?: Record<string, any>;
  };
}
// TODO : As per the requirement, update the form schema to pass data for Updating the holding and holding proxy
export interface UpdateHoldingProxyResponse {
  holdingLink: string;
  holdingProxy: string;
}

export const nestApiGetSingleHoldingProxy = FBF_CloudCallable<
  { holdingProxyLink: string },
  any
>('api/holdingProxies/holdingProxy/:holdingProxyLink|GET');

export const nestApiGetAllHoldingProxies = FBF_CloudCallable<any, any>(
  'api/holdingProxies/all/|GET'
);

export const nestApiRegisterInstallerHoldings = FBF_CloudCallable<any, any>(
  'api/holding/registerInstallerHolding/|POST'
);

export const nestApiUpdateHolding = FBF_CloudCallable<
  UpdateHoldingProxyRequest,
  UpdateHoldingProxyResponse
>('api/holding/updateHolding|PUT');
